import { ButtonHTMLAttributes, forwardRef } from "react";

export const DashboardIconButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className = "", children, ...props }, ref) => {
  return (
    <button
      className={`inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/10 bg-white/0 text-slate-100 transition-colors hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 disabled:cursor-not-allowed disabled:opacity-60 ${className}`.trim()}
      ref={ref}
      {...props}
      data-oid="g.teebj"
    >
      {children}
    </button>
  );
});

DashboardIconButton.displayName = "DashboardIconButton";
